import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaBriefcaseMedical, FaBell, FaSignOutAlt } from 'react-icons/fa';
import { useApp, useRolePath } from '../context/AppContext';
import { getFileUrl } from '../services/api';

const Header = ({ title }) => {
  const { openSidebar, user, logout, badges } = useApp();
  const navigate = useNavigate();
  const rp       = useRolePath();

  const handleLogout = () => {
    const r = user?.role?.toLowerCase() || 'patient';
    logout();
    navigate(`/${r}/login`);
  };

  const initials = user ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'DR';
  const roleLabel = user?.role === 'Admin' ? 'Admin' : user?.role === 'Doctor' ? 'Doctor' : 'Patient';

  return (
    <>
      <style>{`
        .header {
          position: fixed; top: 0; left: 0; right: 0;
          height: var(--header-height);
          background: linear-gradient(135deg, #E8500A 0%, #FF6B2C 100%);
          display: flex; align-items: center; justify-content: space-between;
          padding: 0 16px; z-index: 500;
          box-shadow: 0 2px 12px rgba(232,80,10,0.30);
          transition: left 0.28s cubic-bezier(0.4,0,0.2,1);
        }
        @media (min-width: 768px) {
          .header { left: var(--sidebar-width); }
          .hamburger-btn { display: none !important; }
        }
        .header-left { display: flex; align-items: center; gap: 12px; }
        .hamburger-btn {
          background: rgba(255,255,255,0.18); border: none; width: 38px; height: 38px;
          border-radius: 10px; display: flex; align-items: center; justify-content: center;
          color: white; font-size: 18px; cursor: pointer; transition: background 0.2s;
        }
        .hamburger-btn:hover { background: rgba(255,255,255,0.28); }
        .header-logo-icon {
          background: rgba(255,255,255,0.20); width: 34px; height: 34px;
          border-radius: 8px; display: flex; align-items: center; justify-content: center;
          color: white; font-size: 16px;
        }
        .header-title { display: flex; flex-direction: column; }
        .header-title-main { color: white; font-size: 13px; font-weight: 800; letter-spacing: 0.5px; text-transform: uppercase; line-height: 1.2; }
        .header-title-sub { color: rgba(255,255,255,0.75); font-size: 10px; letter-spacing: 0.5px; }
        .header-right { display: flex; align-items: center; gap: 8px; }
        .header-notif-btn {
          position: relative; background: rgba(255,255,255,0.18); border: none;
          width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center;
          justify-content: center; color: white; font-size: 16px; cursor: pointer; transition: background 0.2s;
        }
        .header-notif-btn:hover { background: rgba(255,255,255,0.28); }
        .notif-dot {
          position: absolute; top: 4px; right: 4px; width: 14px; height: 14px;
          background: #ff4444; border-radius: 50%; font-size: 9px; font-weight: 700;
          color: white; display: flex; align-items: center; justify-content: center;
          border: 2px solid #FF6B2C;
        }
        .header-role-badge {
          padding: 3px 8px; border-radius: 12px; font-size: 10px; font-weight: 700;
          letter-spacing: 0.5px; text-transform: uppercase;
        }
        .header-avatar {
          width: 34px; height: 34px; border-radius: 50%; background: rgba(255,255,255,0.25);
          border: 2px solid rgba(255,255,255,0.5); display: flex; align-items: center;
          justify-content: center; color: white; font-size: 13px; font-weight: 700; cursor: pointer;
          flex-shrink: 0;
        }
        .header-logout-btn {
          background: rgba(255,255,255,0.18); border: none; width: 34px; height: 34px;
          border-radius: 50%; display: flex; align-items: center; justify-content: center;
          color: white; font-size: 15px; cursor: pointer; transition: background 0.2s;
        }
        .header-logout-btn:hover { background: rgba(255,0,0,0.35); }
        @media (max-width: 380px) { .header-title-main { font-size: 11px; } }
      `}</style>
      <header className="header">
        <div className="header-left">
          <button className="hamburger-btn" onClick={openSidebar} aria-label="Open menu">
            <FaBars />
          </button>
          <div className="header-logo-icon"><FaBriefcaseMedical /></div>
          <div className="header-title">
            <span className="header-title-main">DocApps Solutions</span>
            <span className="header-title-sub">{title || 'Medical Management'}</span>
          </div>
        </div>
        <div className="header-right">
          {badges.notifications > 0 && (
            <button className="header-notif-btn" onClick={() => navigate(rp('/notifications'))} aria-label="Notifications">
              <FaBell />
              <span className="notif-dot">{badges.notifications > 9 ? '9+' : badges.notifications}</span>
            </button>
          )}
          <span className="header-role-badge" style={{ background: 'rgba(255,255,255,0.22)', color: 'white' }}>
            {roleLabel}
          </span>
          <div className="header-avatar" onClick={() => navigate(rp('/profile'))} title={user?.name || ''}>
            {user?.profileImage ? (
              <img src={getFileUrl(user.profileImage)} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
            ) : initials}
          </div>
          <button className="header-logout-btn" onClick={handleLogout} title="Logout">
            <FaSignOutAlt />
          </button>
        </div>
      </header>
    </>
  );
};

export default Header;
